module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"-5.5 24.5 12 12\" enable-background=\"new -5.5 24.5 12 12\"><path d=\"M3.9 25.5c0-.5-.4-1-1-1h-5.2c-.5 0-.9.4-.9 1v10.1c0 .5.4.9.9.9h5.2c.5 0 1-.4 1-1v-10zm-2.5 10.1h-2.1c-.2 0-.3-.1-.3-.3 0-.2.1-.4.3-.4h2.1c.2 0 .3.1.3.3 0 .2-.1.4-.3.4zm1.7-1.5h-5.5v-8.5h5.5v8.5z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/hti-phone.svg
// module id = 800
// module chunks = 1